import { defineStore, storeToRefs } from "pinia";
import api from "@/services/api";
import ILabelTemplate from "@/models/responses/ILabelTemplate";
import { useSessionStore } from "@/stores/session.store.ts";
import ILabelTemplateUpsertRequest from "@/models/requests/ILabelTemplateUpsertRequest";
import LabelTemplate from "@/models/frontend/LabelTemplate";
import { useTenantsStore } from "./tenants.store";

export const useLabelTemplatesStore = defineStore("labelTemplates", {
  state: () => ({
    error: "" as any,
    data: [] as LabelTemplate[],
    loadedTenantId: 0,
  }),
  actions: {
    async fetchAll(force = false) {
      const sessionStore = useSessionStore();
      const { selectedTenantId } = storeToRefs(sessionStore);

      if (!force && this.loadedTenantId === selectedTenantId.value) return;
      this.error = "";

      await api
        .get<ILabelTemplate[]>(`v1.0/label-templates`, {
          params: {
            tenantId: selectedTenantId.value,
          }
        })
        .then((response) => {
          this.data = response.data.map((labelTemplate) => this.mapToFrontend(labelTemplate));
          this.loadedTenantId = selectedTenantId.value;
         })
        .catch((error) => (this.error = error));
    },
    async create(template: ILabelTemplateUpsertRequest) {
      this.error = "";
      await api.post(`v1.0/label-templates`, template)
        .catch((error) => (this.error = error));
    },
    async update(templateId: number, template: ILabelTemplateUpsertRequest) {
      this.error = "";
      await api.put(`v1.0/label-templates/${templateId}`, template)
        .catch((error) => (this.error = error));
    },
    async delete(id: number) {
      this.error = "";
      await api.delete(`v1.0/label-templates/${id}`)
        .catch((error) => (this.error = error));
    },
    mapToFrontend(labelTemplate: ILabelTemplate): LabelTemplate {
      const tenant = useTenantsStore().getById(labelTemplate.tenantId);
      return {
        id: labelTemplate.id,
        tenant: tenant,
        code: labelTemplate.code,
        templateContent: labelTemplate.templateContent,
      };
    }
  },
  getters: {
    getById:
      (state) => (id: number): LabelTemplate => {
        return <LabelTemplate>state.data.find((labelTemplate) => labelTemplate.id === id);
      },
    getByCode:
      (state) => (code: string): LabelTemplate => {
        return <LabelTemplate>state.data.find((labelTemplate) => labelTemplate.code === code);
      },
    getAll:
      (state) => (): LabelTemplate[] => {
        return <LabelTemplate[]>state.data;
      },
  }
});
